code

<template>
    <div class="container">
        <div class="row fh-row justify-content-center">
            <div class="col-md-6 pl-0 pr-0 align-self-center">
                <mdb-card class="z-depth-1 card-height">
                  <mdb-card-header color="white">
                    <div class="container-fluid">
                      <div class="row">
                        <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                          <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                          <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                          <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                        </div>
                      </div>
                    </div>
                  </mdb-card-header>
                    <mdb-card-body class="text-center">
                      <div class="container-fluid">
                            <div class="row">
                              <div class="col-12 align-self-center">
                                <mdb-progress class="mb-3" style="width: 100%; float:left"
                                              :height="20" :value="$store.state.step/$store.state.totalSteps * 100">
                                  {{ $store.state.step }}/{{ $store.state.totalSteps }}
                                </mdb-progress>
                              </div>
                            </div>
                            <div v-if="!selectedAgent" class="row hh-row">
                              <h4>{{ $t("handOverToAgent") }}</h4>
                              <div class="col-12 align-self-center">
                                <!--                              <h3>Document Detection Help</h3>-->
                                <h5>{{ $t("selectAgent") }}</h5>
                                <div class="row justify-content-center">
                                  <div class="col-md-6 mb-1 ">
                                    <select class="browser-default custom-select  mb-3" v-model="selectedAgent"
                                            @change="selectAgent"
                                    >
                                      <option selected :value="null">Select Agent</option>
                                      <option :value="agent.id" v-for="agent in agents" :key="agent.id">{{ agent.name }}</option>
                                    </select>
                                  </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="demo" class="row hh-row" @click="changeDemoElements">
                              <div class="col-12 align-self-center">
                                <h3>Agent Liveness</h3>
                                <h5 v-if="demoStep === 'First'" class="text-primary">{{ $t("firstStep") }}</h5>
                                <h5 v-if="demoStep === 'Second'" class="text-primary">{{ $t("secondStep") }}</h5>
                                <h5 v-if="demoStep === 'Third'" class="text-primary">{{ $t("thirdStep") }}</h5>
                                <p class="w-75 mx-auto">{{ instruction }}</p>
                                <img width="250" :src="animation_src" style="background-color: rgb(219 221 225 / 80%);" />
                              </div>
                              <div class="col-12 align-self-center mt-4">
                                <div class="row justify-content-center text-center">
                                  <div class="col-md-12">
                                    <span class="dot" :class="demoStep === 'First'? 'primary-color-dark': ''"></span>
                                    <span class="dot" :class="demoStep === 'Second'? 'primary-color-dark': ''"></span>
                                    <span class="dot" :class="demoStep === 'Third'? 'primary-color-dark': ''"></span>
                                  </div>
                                  <p><b>{{ $t("nextStepMsg") }}</b></p>
                                </div>
                              </div>
                            </div>
                            <div v-else class="hh-row">
                              <div class="col-12 align-self-center">
<!--                                <h4>Agent Verification</h4>-->
                                <webcam-capture-open-c-v_-face :screen_type="'agent_verification'"
                                                               v-on:captureComplete="handleFaceCapture" />
                              </div>
                              <div class="row">
                                <div class="col-12">
                                  <p></p>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </mdb-card-body>
                    <mdb-card-footer>
                      <div class="col-12 align-self-center">
                        <div class="row justify-content-center">
                          <div class="col-md-12 mb-1 mt-1">
                            <mdb-btn
                                :disabled="!validated"
                                block
                                v-if="!demo || !selectedAgent"
                                color="primary"
                                class
                                size="md"
                                style="font-size: 15px"
                                @click="navigate"
                            >{{ $t("next") }}
                              <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                            </mdb-btn>
                            <mdb-btn
                                v-else
                                @click="demo=false"
                                style="font-size: 15px" block color="primary" class="next-btn" size="md">
                              {{ $t("skip") }}
                              <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                            </mdb-btn>
                          </div>
                        </div>
                      </div>
                    </mdb-card-footer>
                </mdb-card>
            </div>
        </div>
        <div id="overlay" v-if="spinner">
            <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>

                </div>
                <p>{{spinner_message}}</p>
            </div>
        </div>
    </div>
</template>

<script>

    import * as centerFace from "../../assets/3D_Face_Center.gif";
    import * as leftFace from "../../assets/3D_Face_Left.gif";
    import * as rightFace from "../../assets/3D_Face_Right.gif";
    import {i18n} from "../../translations";
    import WebcamCaptureOpenCV_Face from "@/components/WebcamCaptureOpenCV_Face";

    export default {
        name: "About",
        components: {
          // eslint-disable-next-line vue/no-unused-components
          WebcamCaptureOpenCV_Face,
        },
        data() {
            return {
                selectedAgent: null,
                agents: [],
                faceDetected: false,
                validated: false,
                spinner:false,
                spinner_message: this.$t("waitMsg"),
                demo: true,
                animation_src: centerFace,
                demoStep: "First",
                isLastStep: false,
                session: {},
                redirect_url: null,
                instruction: this.$t("centerFaceAlignMsg"),
            };
        },
      async mounted() {
          this.spinner = true
          if (this.$store.state.session_id != null) {
            let session = await this.$http.get('/sessions/' + this.$store.state.session_id);
            this.session = session.data
            this.redirect_url = this.session.client_redirect_url
          }
          await this.getAgents()
          this.isLastStep = this.$route.path === this.$store.state.configPath[this.$store.state.configPath.length - 1]
          i18n.locale = this.$store.state.language
          this.$store.commit('assignStep', this.$route.path)
      },
      methods: {
            changeDemoElements() {
              if (this.demoStep === "First") {
                this.animation_src = rightFace
                this.instruction = this.$t("rightFaceAlignMsg")
                this.demoStep = "Second"
              } else if (this.demoStep === "Second") {
                this.animation_src = leftFace
                this.instruction = this.$t("leftFaceAlignMsg")
                this.demoStep = "Third"
              } else if (this.demoStep === "Third") {
                this.demo = false
              }
            },
            navigate() {
              if (this.selectedAgent!== null) {
                this.redirect()
              } else {
                this.showAgentError()
              }
            },
            async selectAgent() {
              this.spinner = true;
              let formData = new FormData()
              formData.append('chosen_agent', this.selectedAgent)

              const urlSearchParams = new URLSearchParams(window.location.search);
              const params = Object.fromEntries(urlSearchParams.entries());
              formData.append("session",this.$store.state.session_id)
              formData.append('meta', params.meta)

              try {
                let response = await this.$http.post("/choose-agent", formData)
                this.spinner = false
                this.$store.commit('setSelectedAgent', {
                  selected_agent: this.selectedAgent
                })
              } catch (error) {
                let msg = ''
                if (error.response && error.response.status === 401) {
                  await this.$router.push('/expired')
                } else {
                  this.showError(error)
                  this.spinner = false;
                }
              }
            },
            async getAgents(){
              this.spinner = true
              this.$http.get('/agents'). then(response => {
                this.agents = response.data
                this.spinner = false;
              }).catch(error => {
                let msg = ''
                if (error.response && error.response.status === 401) {
                  this.$router.push('/expired')
                } else {
                  this.showError(error)
                  this.spinner = false;
                }
              })

            },
            redirect() {
              if (this.isLastStep) {
                let query = new URLSearchParams();
                query.append("session", JSON.stringify(this.session));

                const urlSearchParams = new URLSearchParams(window.location.search);
                const params = Object.fromEntries(urlSearchParams.entries());

                query.append("session", JSON.stringify(this.session));
                query.append("meta", JSON.stringify(params.meta));
                window.location.href = this.redirect_url+"?"+query.toString()

                this.spinner = false;

                this.$localForageService.clear();
                this.$store.commit("setExtractTextState", {
                  state: false,
                  data: false
                });
                this.$store.commit("setTrustedPartnerState", {
                  name: "",
                  number: ""
                });
                this.$store.commit("setSessionID", {
                  session_id: null,
                  agent_name: null
                })
                this.$store.commit('setManualVerification', {
                  manual_verification: false
                })
                this.$store.commit('setSelectedAgent', {
                  selected_agent: null
                })
              } else {
                const urlSearchParams = new URLSearchParams(window.location.search);
                const params = Object.fromEntries(urlSearchParams.entries());
                this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params})
                this.spinner = false;
              }
            },
            async handleFaceCapture(image, video) {
                this.validated = true;

              let formData = new FormData();
              let document_status = "";
              if  (this.session.report && this.session.report.document_authenticity) {
                document_status = this.session.report.document_authenticity.status
              }
              if ([false, "pending", "Pending"].includes(document_status)) {
                let manual_popup_status = await this.showManualPopup()
                this.$store.commit('setManualVerification', {
                  manual_verification: manual_popup_status.value
                })
              }
              if (this.$store.state.manual_verification === true){
                  formData.append("manual_verification",true)
              }
              this.spinner = true;

              formData.append("session", this.$store.state.session_id)
              formData.append("image", image)
              try {
                let init_session_response = await this.$http.post("/upload-pose-agent-frame", formData);
                this.spinner = false
                if (init_session_response.data.status === false) {
                  await this.$router.push('/complete')
                } else {
                  await this.$localForageService.setItem("agentImage", image);
                  await this.$localForageService.setItem("agentVideo", video);
                  // this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params})
                  this.redirect()
                }
              }
              catch (err){
                this.spinner = false

                if (err.response.status === 400){
                  if ('non_field_errors' in err.response && err.response.non_field_errors.length>0){
                    this.showError(err.response.non_field_errors[0])
                  }
                  else if ('data' in err.response){
                    if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length>0){
                      this.showError(err.response.data.non_field_errors[0])
                    }
                    else {
                      if (Array.isArray(err.response.data) && err.response.data.length>0) {
                        let error = err.response.data[0]
                        if (typeof err.response.data[0] !== "string") {
                          error = JSON.stringify(error)
                        }
                        this.showError(error)
                      }
                      else {
                        this.showError(JSON.stringify(err.response.data))
                      }

                    }

                  }
                  else{
                    this.showError(JSON.stringify(err.response))
                  }
                } else if (err.response && err.response.status === 401) {
                  await this.$router.push('/expired')
                }
                else {
                  this.showError(err.response)
                }
              }
            },
            showManualPopup() {
              const options = {
                title: this.$t("cardNotVerified"),
                text: this.$t("manuallyVerify"),
                icon: "question",
                showCancelButton: true,

                confirmButtonText: this.$t("yes"),
                cancelButtonText: this.$t("no"),
                allowOutsideClick: false,
                allowEscapeKey: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: "btn btn-primary btn-md ripple-parent",
                  cancelButton: "btn  btn-md ripple-parent"
                },
                buttonsStyling: false,
              };
              return this.$swal.fire(options)
            },
            showError(message, cancelButton=false) {
            const options = {
              title: message,
              text: '',
              icon: 'question',
              showCancelButton: cancelButton,

              confirmButtonText: this.$t("retryRequest"),
              cancelButtonText: this.$t("no"),
              allowOutsideClick: false,
              allowEscapeKey: false,
              focusConfirm: false,
              customClass: {
                confirmButton: "btn btn-primary btn-md ripple-parent",
                cancelButton: "btn  btn-md ripple-parent"
              },
              buttonsStyling: false,
            };

            this.$swal.fire(options).then(res => {
              if (res.value) {
                window.location.reload();
                // eslint-disable-next-line no-undef
              } else if (res.dismiss === "cancel") {
                this.redirect()
              }
            })

          },
            showAgentError() {
            const options = {
              title: "Agent not Selected",
              text: "Do you want to go to next step without agent",
              icon: "question",
              showCancelButton: true,

              confirmButtonText: 'Yes',
              cancelButtonText: "No",
              allowOutsideClick: false,
              allowEscapeKey: false,
              focusConfirm: false,
              customClass: {
                confirmButton: "btn btn-primary btn-md ripple-parent",
                cancelButton: "btn  btn-md ripple-parent"
              },
              buttonsStyling: false,
            };

            this.$swal.fire(options).then(res => {
              if (res.value) {
                const urlSearchParams = new URLSearchParams(window.location.search);
                const params = Object.fromEntries(urlSearchParams.entries());
                this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params});
                // eslint-disable-next-line no-undef
              }
            })

          }
        }
    };
</script>
<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

    $image-path: "~@/../mdb/mdbvue/img";
</style>
